import classNames from "classnames";
import React from "react";

export const statusBodyTemplate = (e) => {
  let type = "-";
  if (e.pnmt_situacao === "SOLICITADA" || e.pnmt_situacao === "APROVADA") {
    type = "bg-sky-200 text-sky-600";
    //   value = "EM ABERTO";
  }
  if (e.pnmt_situacao === "NEGOCIADA") {
    type = "bg-emerald-300 text-emerald-800";
    // value = 'BAIXA CLIENTE';
  }
  if (e.pnmt_situacao === "EM ANALISE") {
    type = "bg-orange-300 text-orange-700";
    //   value = 'EM PROCESSAMENTO';
  }
  if (e.pnmt_situacao === "EM CONTRA PROPOSTA") {
    type = "bg-amber-300 text-amber-700";
    //   value = 'EM PROCESSAMENTO';
  }
  if (e.pnmt_situacao === "NEGADA" || e.pnmt_situacao === "BLOQUEADA") {
    type = "bg-red-300 text-red-700";
    //   value = 'PAGO';
  }
  return (
    <div className="flex justify-center items-center ">
      <span className={classNames(
        'text-nowrap py-1 px-2 justify-center flex w-auto',
        type
      )}
      >
        <p className="uppercase text-sm font-bold">
          {e.pnmt_situacao}
        </p>
      </span>
    </div>
  );
};